/**
 * Defines members of Product - account used for update, it contains only product number and enabled flag.
 *
 * https://int0csaspsd2selfservice.docs.apiary.io/#reference/aisp/pisp
 *          /nastaveni-opravneni-smazani-aplikace/nastaveni-opravneni-k-uctum-pro-danou-aplikaci-a-klienta
 *
 * ### Example
 *
 * ```
 *  {
 *     'number': '123/0800',
 *     'enabled': true
 *  }
 * ```
 */
export class ProductUpdate {
    number: string;
    enabled: boolean;

    constructor(number: string, enabled: boolean) {
        this.number = number;
        this.enabled = enabled;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/model/account-group/product-update.model.ts